import { z } from 'zod'

import { DateZod } from '../common'

export const ChannelIdZod = z.enum(['lounge'])
export type ChannelId = z.infer<typeof ChannelIdZod>

export const LOUNGE_CHANNEL_ID: ChannelId = 'lounge'

// The security rules carry the same list inline: firestore.rules cannot import from a package.
export const CHANNEL_MODERATOR_PERMISSIONS = ['central_admin', 'allocation', 'assignment'] as const

export const ChannelZod = z.object({
  regionId: z.string(),
  channelId: ChannelIdZod,
})

export type Channel = z.infer<typeof ChannelZod>

export const ChannelEveningZod = z.object({
  regionId: z.string().nullish(),
  channelId: ChannelIdZod.nullish(),
  eveningId: z.number().nullish(),
  lastMessageAt: DateZod.nullish(),
  lastMessageSenderId: z.string().nullish(),
})

export type ChannelEvening = z.infer<typeof ChannelEveningZod>
